import React, { Component } from "react";
import {  Feed, Container, Dropdown, Header, Form, Modal, Input, Button, Icon, Divider } from 'semantic-ui-react'
import { invokeApig, downloadS3Text, downloadS3 } from "../libs/awsLib";
import { formatDateTime, formatXml } from "../libs/sharedFunctions";
import LoadingPage from "./LoadingPage"
import ErrorPage from "./ErrorPage"  
import SmartServiceRequestModal from "./SmartServiceRequestModal"
import FunctionModal from "./FunctionModal"
import ReactJson from 'react-json-view'
import config from "../config";
import XMLBeautify from 'xml-beautify';

export default class SmartEvents extends Component {
  constructor(props) {
    super(props);
    this.state={events: [], isLoading: true, showServiceRequest: false, serviceReferenceVariant: null, servicerequests: [], userservicerequests: [], showEventId: null, showFunction: false, functions: [], functionParameters: [], hidesrv481: true, showXml: false, xml: "", functionFilter: "", eventFilter: "", showTestEvent: false, eventType: "", eventXML: "", testXML: {"dccalerts": {}, "devicealerts": {}, "deviceresponses": {}, "dccresponses": {}}};

  }

  loadServiceRequests()
  {
    invokeApig({path: '/smart/servicerequests' , method: "GET"}).then((result)=>{
      const userSRs=result.data.filter(servicerequest=>{return this.props.user.functions.indexOf('smartsr'+servicerequest.servicereferencevariant)>-1 });
      this.setState({servicerequests: userSRs})
    });
  }


  loadFunctions()
  {
    invokeApig({path: '/entities/smartdevice/functions' , method: "GET"}).then((result)=>{
      this.setState({functions: result.data.filter(functiondef=>{return !functiondef.name.startsWith('smartsr') && this.props.user.functions.indexOf(functiondef.name)>-1 })})
    });
  }

  showFunction= (functionname)=>{
    //console.log(eventid);
    var parameters={parententityname: "smartdevice", parententityid: this.props.smartdeviceid}
    this.setState({showFunction: true, functionname: functionname, functionParameters: parameters});
  }    

  closeFunction=(refresh)=>{
    this.setState({showFunction: false, functionname: null})
    if(refresh)       
    this.loadEvents(this.props.smartdeviceid)

  }

  loadTestXML()
  {
    downloadS3Text(config.S3Bucket, "config/smarttestxml.json").then(data=>{
      this.setState({testXML: data})
    })
  }

  loadEvents(smartdeviceid) {
    
    //get view data    
    invokeApig({path: '/smart/smartdevices/' +smartdeviceid+'/events' , method: "GET"}).then((result)=>{
      
      if(result.status===200) 
      {this.setState({isLoading: false, events: result.data, loadError: false})}  
      else if (result.status===404)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Page not found', loadErrorDetail: 'The page you requested was not found'})
      }
      else if (result.status===400)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Error loading page', loadErrorDetail: result.data})
      }    
      else if (result.status===401)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Permission denied', loadErrorDetail: 'You are not authorised to view this page'})
      }     
      else if (result.status===502)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'API Error', loadErrorDetail: 'The API returned an error'})
      }          
      else 
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Unexpected return code' + result.status, loadErrorDetail: result.data})
      }        
      
    }).catch(e=>
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'An error occurred submitting the request', loadErrorDetail: []})
      })
    
  }


  componentDidMount ()
  {
    this.loadEvents(this.props.smartdeviceid)
    this.loadServiceRequests();
    this.loadFunctions();
    this.loadTestXML();
  }

  componentWillReceiveProps(newProps)
  {
    if (newProps.smartdeviceid != this.props.smartdeviceid)
    {
      this.setState({isLoading: true})
      this.loadEvents(newProps.smartdeviceid)
    }
  }
 
  showServiceRequest= (serviceReferenceVariant)=>{
    this.setState({showServiceRequest: true, serviceReferenceVariant: serviceReferenceVariant});
  }    

  closeServiceRequest=(refresh)=>{
    this.setState({showServiceRequest: false, serviceReferenceVariant: null})
    if(refresh)       
    this.loadEvents(this.props.smartdeviceid)

  }

  testEventDescription=()=>{
    if (this.state.eventType==="dccalert")
      return "Send " +this.state.alertcode + " DCC Alert"
    else if (this.state.eventType==="devicealert")
      return "Send " +this.state.alertcode + " Device Alert"
    else if (this.state.eventType==="deviceresponse")
      return "Send " +this.state.serviceReferenceVariant + " Device Response"


    }

  raiseTestEvent=()=>{
    var payload;
    if (this.state.eventType==="dccalert")
      payload={eventType: "DCCAlert", deviceId: this.props.deviceid, "alertCode": this.state.alertcode, xml: this.state.eventXML }
    else if (this.state.eventType==="devicealert")
      payload={eventType: "DeviceAlert", deviceId: this.props.deviceid, "alertCode": this.state.alertcode, responseCode: "I0", xml: this.state.eventXML }
    else if (this.state.eventType==="deviceresponse")
      payload={eventType: "DeviceResponse", deviceId: this.props.deviceid, "srv": this.state.serviceReferenceVariant, responseCode: "I0", xml: this.state.eventXML }
    else if (this.state.eventType==="dccresponse")
      payload={eventType: "DCCResponse", deviceId: this.props.deviceid, "srv": this.state.serviceReferenceVariant, xml: this.state.eventXML }

      
    invokeApig({path: '/smart/events' , method: "POST", body: payload, api: "sgsmart"}).then(result=>{this.loadEvents(this.props.smartdeviceid); this.setState({showTestEvent: false})})


  }  

  loadEventDetail(entityname, entityinstanceid, eventid) {
    
    invokeApig({path: '/smart/' + entityname + 's/' +entityinstanceid+'/events' , method: "GET", queryParams: ["eventid="+eventid]}).then((result)=>{
      
      if(result.status===200) 
      {this.setState({xml: formatXml(result.data[0].xml)})}      
    }).catch(e=>
      {
        {this.setState({xml: []})}
      })
    
  }

  loadxmlEventData=(eventid)=>{
    this.loadEventDetail("smartdevice", this.props.smartdeviceid, eventid);
    this.setState({showXml: true});

   }

  render() {
  const modalStyle = {
      modal : {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    };


    if (this.state.isLoading) 
    return (
    <LoadingPage />
    )
    else if (this.state.loadError)
    return (
      <Container>
      <ErrorPage visible={true} messageHeader={this.state.loadErrorHeader} messageDetail={this.state.loadErrorDetail}/>
      </Container>
    )
    else
      
    return (
    <div> 
    {this.state.servicerequests.length>0 && <Dropdown className='seaglassbutton icon'  text='Send Service Request' icon='send' button labeled>
             <Dropdown.Menu style={{color: "black"}}>
    <Input icon="search" iconPosition="left" className="search" value={this.state.functionFilter} onChange={(event, data)=>this.setState({functionFilter: data.value})}  onClick={e => e.stopPropagation()}/>
    {this.state.functions.filter(functiondef=>{return functiondef.title.toLowerCase().includes(this.state.functionFilter.toLowerCase())}).map(functiondef=>{return <Dropdown.Item onClick={()=>{this.showFunction(functiondef.name)}} content={functiondef.title}/>})}
    <Dropdown.Divider/>
    {this.state.servicerequests.filter(servicerequest=>{return (servicerequest.servicereferencevariant+ ' ' + servicerequest.description).toLowerCase().includes(this.state.functionFilter.toLowerCase())}).map(servicerequest=>{return <Dropdown.Item onClick={()=>{this.showServiceRequest(servicerequest.servicereferencevariant)}} content={servicerequest.servicereferencevariant+ ' ' + servicerequest.description}/>})}
    </Dropdown.Menu>
    </Dropdown>}
    {!config.production && <Dropdown className='seaglassbutton icon'  text='Raise Test Event' icon='add' button labeled>
    <Dropdown.Menu style={{color: "black"}}>
    <Dropdown.Item>
    <Dropdown text="DCC Alerts">
    <Dropdown.Menu style={{color: "black"}}>
    {Object.keys(this.state.testXML.dccalerts).map(alertcode=>{return <Dropdown.Item content={alertcode} onClick={()=>{this.setState({showTestEvent: true, eventType: "dccalert", alertcode: alertcode, eventXML: formatXml(this.state.testXML.dccalerts[alertcode])})}}/>})}
    </Dropdown.Menu>
    </Dropdown>
    </Dropdown.Item>
    <Dropdown.Item>
    <Dropdown text="DCC Responses">
    <Dropdown.Menu style={{color: "black"}}>
    {Object.keys(this.state.testXML.dccresponses).map(srv=>{return <Dropdown.Item content={srv} onClick={()=>{this.setState({showTestEvent: true, eventType: "dccresponse", serviceReferenceVariant: srv, eventXML: formatXml(this.state.testXML.dccresponses[srv])})}}/>})}
    </Dropdown.Menu>
    </Dropdown>
    </Dropdown.Item>        
    <Dropdown.Item>
    <Dropdown text="Device Alerts">
    <Dropdown.Menu style={{color: "black"}}>
    {Object.keys(this.state.testXML.devicealerts).map(alertcode=>{return <Dropdown.Item content={alertcode} onClick={()=>{this.setState({showTestEvent: true, eventType: "devicealert", alertcode: alertcode, eventXML: formatXml(this.state.testXML.devicealerts[alertcode])})}}/>})}
    </Dropdown.Menu>
    </Dropdown>
    </Dropdown.Item>
    <Dropdown.Item>
    <Dropdown text="Device Responses">
    <Dropdown.Menu style={{color: "black"}}>
    {Object.keys(this.state.testXML.deviceresponses).map(srv=>{return <Dropdown.Item content={srv} onClick={()=>{this.setState({showTestEvent: true, eventType: "deviceresponse", serviceReferenceVariant: srv, eventXML: formatXml(this.state.testXML.deviceresponses[srv])})}}/>})}
    </Dropdown.Menu>
    </Dropdown>
    </Dropdown.Item>    
    </Dropdown.Menu>
    </Dropdown>}
    <Button className="seaglassbutton" onClick={()=>{this.setState({isLoading: true});this.loadEvents(this.props.smartdeviceid);}}><Icon name='refresh'/>Refresh</Button>
    <Input icon="search" placeholder="Search events ..." iconPosition="left" className="search" value={this.state.eventFilter} onChange={(event, data)=>this.setState({eventFilter: data.value})}  onClick={e => e.stopPropagation()}/>

    <Feed className="devicedetail">
    
    {this.state.events. map(event=>{
      var eventIcon;
      var eventSource;

        var eventSummmary='';
        var eventIcon='';
        var eventDetail=[];

        if (event.typeid===800)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' Sent'
          eventIcon='arrow right'
          if ('responsedetails' in event)
            eventDetail.push(event.responsedetails)          
       
        }
        else if (event.typeid===801)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' Failed'
          eventIcon='close'
          eventDetail.push(event.responsedetails)
        }
        else if (event.typeid===802)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' DCC Response Received'
          eventIcon='arrow left'
          if ('responsedetails' in event)
            eventDetail.push(event.responsedetails)
        }
        else if (event.typeid===803)
        {
          eventSummmary=event.alertdescription ? (event.alertdescription + ' (Device Alert '+event.alertcode+ ')') : ('Device Alert ' + event.alertcode + ' Received')
          eventIcon='exclamation'
        }
        else if (event.typeid===804)
        {
          eventSummmary=event.alertdescription ? (event.alertdescription + ' (DCC Alert '+event.alertcode+ ')') : ('DCC Alert ' + event.alertcode + ' Received')
          eventIcon='exclamation'
          // if ('xml' in event)
          // eventDetail.push(event.xml)
          // eventDetail=event.data.response.failreason
        }
        else if (event.typeid===807)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' Device Response Received'
          eventIcon='arrow left'
          if ('responsedetails' in event)
            eventDetail.push(event.responsedetails)

        }
        else if (event.typeid===808)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' Sent'
          eventIcon='arrow right'
        }
        else if (event.typeid===809)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' Acknowledgement Received'
          eventIcon='check'
        }
        else if (event.typeid===810)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' Accepted'
          eventIcon='check'
        }
        else if (event.typeid===811)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' Rejected'
          eventIcon='x'
          if ('responsedetails' in event)
          eventDetail.push(event.responsedetails)
        }
        else if (event.typeid===812)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' Update Received'
          eventIcon='edit'
          if ('responsedetails' in event)
          eventDetail.push(event.responsedetails)
        }
        else if (event.typeid===813)
        {
          eventSummmary=event.servicereferencevariant + ' ' + event.servicerequestname +' Alert Received'
          eventIcon='exclamation'
          if ('responsedetails' in event)
          eventDetail.push(event.responsedetails)
        }
        else if (event.typeid===816)
        {
          eventSummmary='Device Cerficate Generated'
          eventIcon='certificate'
        }
        if (this.state.eventFilter==="" || eventSummmary.toLowerCase().includes(this.state.eventFilter.toLowerCase()))        
        return <Feed.Event>
        <Feed.Label icon={eventIcon} />
        <Feed.Content>
        <Feed.Summary style={{color: this.props.darkmode ? "white": "black"}}>{eventSummmary}<Feed.Date style={{color: this.props.darkmode ? "white": "black"}}>{formatDateTime(new Date(event.datetime))}</Feed.Date>
        </Feed.Summary>
        <Feed.Extra style={{color: this.props.darkmode ? "white": "black"}}>{eventDetail.join('/n')}
        {'xml' in event && <a onClick={()=>this.loadxmlEventData(event.id)}> view xml</a>}
        {'jsondata' in event && <div>
          {/* {this.state.showEventId===null && <a onClick={()=>{this.setState({showEventId: event.id})}}>view data</a>}
          {this.state.showEventId===event.id && <a onClick={()=>{this.setState({showEventId: null})}}>hide data</a>} */}
          {/* {this.state.showEventId===event.id && <ReactJson src={event.jsondata} name={false} collapsed={true} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false} />} */}
          <ReactJson src={event.jsondata} name={false} collapsed={true} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false} theme={this.props.darkmode ? "summerfruit" : "summerfruit:inverted"} />
          </div>}
        {/* <a onClick={()=>{this.showActions(event.id)}}>view detail</a> */}
        </Feed.Extra>
        </Feed.Content>

        </Feed.Event>
    })}
    <SmartServiceRequestModal visible={this.state.showServiceRequest} servicereferencevariant={this.state.serviceReferenceVariant} parententity={"smartdevice"} parententityid={this.props.smartdeviceid} closefunctionmodal={this.closeServiceRequest} />
    <FunctionModal visible={this.state.showFunction} functionName={this.state.functionname} parententity={"smartdevice"} parententityid={this.props.smartdeviceid} closefunctionmodal={this.closeFunction} parameters={this.state.functionParameters} />
    <Modal style={modalStyle.modal} open={this.state.showXml} closeIcon onClose={()=>{this.setState({showXml: false, xml: ""})}}><Modal.Content><div className="xmlmodal"><Button className="seaglasssecondarybutton" onClick={() => {navigator.clipboard.writeText(this.state.xml)}}><Icon name="copy"/>Copy</Button><pre>{this.state.xml}</pre></div></Modal.Content></Modal>
    <Modal  style={modalStyle.modal}open={this.state.showTestEvent}>
      <Modal.Content>
    <Header as='h5'>{this.testEventDescription()}</Header>
        <div className="xmlmodal">
          <Form>
            <Form.TextArea rows="20" label="XML" placeholder="XML" onChange={(event, data)=>{this.setState({eventXML: data.value})}}>{this.state.eventXML}</Form.TextArea>
          </Form>
        </div>
        <Divider/>
        {/* <Button className="seaglassbutton" onClick={()=>{this.raiseTestEvent();}}><Icon name='check'/>OK</Button> */}
        <Button className="seaglassbutton" onClick={()=>{this.setState({showTestEvent: false});}}><Icon name='x'/>Close</Button>
      </Modal.Content>
    </Modal>
    </Feed>
    </div>  
    )
  }
}